import * as React from 'react'

import { ProductContent } from '@common'

import { DisplayAsset } from '../../../../../../assetRendering/DisplayAsset'

export const ClashProductVideo = ({ content }: { content: ProductContent }) => {
  return <DisplayAsset headerAsset gameId="clashofclans" content={content} preferAnimated />
}
